import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useList() {
  // Use toast
  const toast = useToast()

  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id', sortable: true, label: 'Nomor Konsultasi' },
    { key: 'tanggal_mulai', sortable: true, label: 'Tanggal Input Asistensi' },
    { key: 'tanggal_selesai', sortable: true, label: 'Tanggal Selesai' },
    { key: 'kategori_tiket', sortable: true, label: 'Kategori' },
    { key: 'sub_kategori_tiket', sortable: true, label: 'Jenis Pekerjaan' },
    { key: 'upt', sortable: true, label: 'UPT' },
    { key: 'kanwil', sortable: true, label: 'Kanwil' },
    { key: 'created_by', sortable: true, label: 'Pelapor' },
    { key: 'created_email', sortable: true, label: 'Email Pelapor' },
    { key: 'permasalahan', sortable: true },
    { key: 'solusi', sortable: true },
    { key: 'status_tiket', sortable: true, label: 'Status' },
    // { key: 'nama_helpdesk', sortable: true },
    { key: 'helpdesk_tiket[0].name', label: 'Nama Helpdesk', sortable: true },
    // { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const tahunFilter = ref(null)
  const bulanFilter = ref(null)
  const kanwilFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refUserListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, tahunFilter, bulanFilter, kanwilFilter], () => {
    refetchData()
  })

  const fetchDatas = (ctx, callback) => {
    store
      .dispatch('report-list-kategori/fetchDatas', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        tahun_filter: tahunFilter.value,
        bulan_filter: bulanFilter.value,
        kanwil_filter: kanwilFilter.value,
      })
      // console.log(newSearch.value)
      .then(response => {
        // console.log(response)
        const { data, total } = response.data

        callback(data)
        totalUsers.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Tidak dapat mengambil data',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchDatas,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    // Extra Filters
    tahunFilter,
    bulanFilter,
    kanwilFilter,
  }
}
